import React from 'react';
import { Box, Typography, Button, Card } from '@mui/material';
import styled from '@emotion/styled';
import { Container } from './style';
import { useNavigate } from 'react-router-dom';
import buttonIcon from '../../../assets/sendMessageNew.png';
import sendMessage from '../../../assets/buttoniconnew.png';
import messageHistoryIcon from '../../../assets/messageHistory.svg';
import messageRulesIcon from '../../../assets/messageRules.svg';
import draftsIcon from '../../../assets/drafts.svg';
import scheduledMessage from '../../../assets/scheduledMessage.svg';

const FlatButton = styled(Button)(
   ({ theme }) => `
background: #0040BF;
color: #FFFFFF;
font-weight: 400;
width: 47%;
text-align: center;
position: relative;
padding:'10px 0';
border-radius: 8px;
transition: background-color 0.3s ease;
&:hover {
	background: #003399;
}
@media(max-width:550px) {
	width: 100%;
}
`
);

const MessageHome = () => {
   const navigate = useNavigate();
   return (
      <Container>
         <Card
            sx={{
               width: {xs:'100%', sm:'90%'},
               maxWidth: '630px',
               margin: '0 auto',
               position: 'relative',
               boxShadow:
                  '0px 1px 2px rgba(0, 0, 0, 0.3), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)',
               padding: '20px ',
               background: 'white',
               paddingLeft: { xs: '1rem', sm: '4rem' },
               paddingRight: { xs: '1rem', sm: '4rem' },
               borderRadius:'12px',
               paddingBottom:'1.6rem'
            }}
         >
            <Box
               sx={{
                  margin: '0 auto',
               }}
            >
               <Typography
                  sx={{
                     textAlign: 'center',
                     fontSize:{ xs: '2rem', sm:'2.5rem',md:'2.5rem'} ,
                     fontWeight: '600',
                     marginTop: '1rem',
                     color:'#2E2C21',
                  }}
                  className='font-cormorant'
               >
                  Messages
               </Typography>
               <Box
                  sx={{
                     display: 'flex',
                     justifyContent: 'space-between',
                     marginTop: '2rem',
                     '@media(max-width: 550px)': {
                        flexDirection: 'column',
                        alignItems: 'center',
                        rowGap: '20px',
                     },
                  }}
               >
                  <FlatButton
                     sx={{
                        color: '#374DA0',
                        
                     }}
                     onClick={() => navigate('/send-message/verify')}
                  >
                     <img
                        src={buttonIcon}
                        style={{
                           marginRight: '10px',
                           width: '30px',
                        }}
                        alt="icon"
                     />
                     <Typography
                        sx={{
                           color: '#FFFFFF',
                           fontWeight: 400,
                           fontSize: 'clamp(1rem, 1.5vw, 1.1rem)',
                        }}
                     >
                        Apply for Sender ID
                     </Typography>
                  </FlatButton>
                  <FlatButton
                     onClick={() => navigate('/send-message/message')}
                     sx={{
                        color: '#374DA0',
                     }}
                  >
                     <img
                        src={sendMessage}
                        style={{
                           marginRight: '10px',
                           width: '30px',
                        }}
                        alt="icon"
                     />
                     <Typography
                        sx={{
                           color: '#FFFFFF',
                           fontWeight: 400,
                           fontSize: 'clamp(1rem, 1.5vw, 1.1rem)',
                        }}
                     >
                        Send Message
                     </Typography>
                  </FlatButton>
               </Box>
               <Box
                  sx={{
                     margin: '2rem 0',
                     display: 'flex',
                     columnGap: '15px',
                     rowGap: '15px',
                     flexWrap: 'wrap',
                     '& > *:hover': {
                        transform: 'scale(1.02)',
                     },
                  }}
               >
                  <Box
                     sx={{
                        width: '48%',
                        height: '140px',
                        background: '#f9f5de',
                        borderTopLeftRadius: '16px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        '@media (max-width: 460px)': {
                           width: '100%',
                           borderTopRightRadius: '16px',
                        },
                     }}
                     onClick={() => navigate('/send-message/history')}
                  >
                     <img
                        src={messageHistoryIcon}
                        style={{ width: '30px', marginBottom: '1rem' }}
                        alt="icon"
                     />
                     <Typography
                        sx={{
                           fontWeight: 400,
                           fontSize:'1.2rem',
                           color:'#2E2C21'
                        }}
                     >
                        Message History
                     </Typography>
                  </Box>
                  <Box
                     sx={{
                        width: '48%',
                        height: '140px',
                        background: '#f9f5de',
                        borderTopRightRadius: '16px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        '@media (max-width: 460px)': {
                           width: '100%',
                           borderTopRightRadius: 0,
                        },
                     }}
                     onClick={() => navigate('/send-message/rules')}
                  >
                     <img
                        src={messageRulesIcon}
                        style={{ width: '30px', marginBottom: '1rem' }}
                        alt="icon"
                     />
                     <Typography
                        sx={{
                           fontWeight: 400,
                           fontSize:'1.2rem',
                           color:'#2E2C21'
                        }}
                     >
                        Message Guidelines
                     </Typography>
                  </Box>
                  <Box
                     sx={{
                        width: '48%',
                        height: '140px',
                        background: '#f9f5de',
                        borderBottomLeftRadius: '16px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        '@media (max-width: 460px)': {
                           width: '100%',
                           borderBottomLeftRadius: 0,
                        },
                     }}
                     onClick={() => navigate('/send-message/schedule')}
                  >
                     <img
                        src={scheduledMessage}
                        style={{ width: '30px', marginBottom: '1rem' }}
                        alt="icon"
                     />
                     <Typography
                        sx={{
                           fontWeight: 400,
                           fontSize:'1.2rem',
                           color:'#2E2C21'
                        }}
                     >
                        Schedule Message
                     </Typography>
                  </Box>
                  <Box
                     sx={{
                        width: '48%',
                        height: '140px',
                        background: '#f9f5de',
                        borderBottomRightRadius: '16px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        '@media (max-width: 460px)': {
                           width: '100%',
                           borderBottomLeftRadius: '16px',
                        },
                     }}
                     onClick={() => navigate('/send-message/drafts')}
                  >
                     <img
                        src={draftsIcon}
                        style={{ width: '30px', marginBottom: '1rem' }}
                        alt="icon"
                     />
                     <Typography
                        sx={{
                           fontWeight: 400,
                           fontSize:'1.2rem',
                           color:'#2E2C21'
                        }}
                     >
                        Draft
                     </Typography>
                  </Box>
               </Box>
            </Box>
         </Card>
      </Container>
   );
};

export default MessageHome;
